import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { Subscription, firstValueFrom } from 'rxjs';
import { SearchRequest } from 'src/app/common/models/search-request';
import { StudyTitle } from 'src/app/common/models/study-title';
import { DetailsService } from 'src/app/common/services/details.service';
import { PreviewContentService } from 'src/app/common/services/preview-content.service';
import { SearchService } from 'src/app/common/services/search.service';
import { LoadingService } from './../../common/services/loading.service';
import { Identifier } from 'src/app/common/models/identifier';

@Component({
  selector: 'rpc-protocol-details',
  templateUrl: './protocol-details.component.html',
  styleUrls: ['./protocol-details.component.scss']
})
export class ProtocolDetailsComponent implements OnDestroy {

  irbNumber!: string;
  study!: StudyTitle;

  isDetailsBookMarked: boolean = false;

  isFromPISummary: boolean = false;

  faAngleLeft = faAngleLeft;

  searchCriteria: SearchRequest = {
    areaOfInterest: [],
    irbProtocol: [],
    status: [],
    location: [],
    phase: [],
    gender: [],
    population: [],
    additionalFilters: [],
    diseaseGroupCategories: [],
    studyType: [],
    sponsor: [],
    page: 0
  };


  tabs = [
    {
      label: 'Details',
      route: 'detail'
    },
    {
      label: 'Contacts',
      route: 'contact'
    },
    {
      label: 'More Info',
      route: 'more-info'
    }

  ];

  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private detailsService: DetailsService,
    private searchService: SearchService,
    private loadingService: LoadingService,
    private previewContentService: PreviewContentService
  ) {
    this.irbNumber = this.route.snapshot?.params['irbNumber'];
    this.subscriptions.push(
      this.detailsService
        .getStudyTitleV2(this.irbNumber)
        .subscribe((res) => {
          this.study = res;
          this.detailsService.studyTitle = res;

          // If we get the Mayo IRB Number, get the study details and save them to the DetailsService
          if (this.detailsService.studyTitle?.mayoIrbNumber) {
            this.subscriptions.push(
              this.detailsService.getStudyDetail(this.detailsService.studyTitle.mayoIrbNumber).subscribe((details) => {
                if (details) {
                  this.detailsService.studyDetails = details;
                }
              })
            );
          }
        })
    );

    firstValueFrom(searchService.lastSearchRequest).then(value => {
      if (!value) {
        this.isDetailsBookMarked = true;
      }
    });

    this.subscriptions.push(
      this.previewContentService.fromPISummary.subscribe((value) => {
        this.isFromPISummary = value;
      })
    );

  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(sub =>
        sub.unsubscribe()
      );
    }
  }

  /**
   * Handle back to protocol results
   */
  backToSearchResults(): void {
    this.loadingService.setIsSearchApiCall(true);
    this.router.navigate(['/home']);
    this.previewContentService.setRouteToPISummary(null);
  }

  /**
  * Handle back to PI Summary
  */
  backToPISummary(): void {
    this.router.navigate(['/home']);
    this.previewContentService.setRouteToPISummary(this.study.protocol);
  }

}
